module.exports = __webpack_public_path__ + "static/media/header_light.67607d0f.png";